import { FunctionComponent, MouseEvent, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import sprite from '../../../assets/icons/sprite.svg';
import { CircularLoader } from '../CircularLoader';

import classNames from 'classnames';
import classes from './FollowToggle.module.scss';

interface FollowToggleProps {
  followed: boolean;
  isPending: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  hideBorder?: boolean;
  className?: string;
}

export const FollowToggle: FunctionComponent<FollowToggleProps> = memo(
  ({ followed, isPending, onClick, hideBorder, className }) => {
    const { t } = useTranslation();

    const icon = useMemo(() => {
      if (isPending) {
        return (
          <CircularLoader className={classes['follow__loader']} sizeRem={0.875} borderRem={0.125} />
        );
      }

      return (
        <svg className={classes['follow__icon']}>
          <use href={`${sprite}#${followed ? 'checkmark' : 'add-plus'}`} />
        </svg>
      );
    }, [followed, isPending]);

    return (
      <button
        type={'button'}
        className={classNames(classes['follow'], className, {
          [classes['follow--following']]: followed,
          [classes['follow--hide-border']]: hideBorder,
        })}
        aria-pressed={followed}
        disabled={isPending}
        onClick={onClick}
      >
        {icon}
        <span>{t(`common.${followed ? 'following' : 'follow'}`)}</span>
      </button>
    );
  }
);
